// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + {"532":"styles","678":"component---src-pages-index-js","883":"component---src-pages-404-js"}[chunkId] + "-" + {"532":"bdd219058e5abde767ee","678":"c200da1d63ffb64a5901","883":"0e584f0261d64f512663"}[chunkId] + ".js";
};